import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import { dateToYMDformat, toLongDate } from 'utils/date'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useParams } from 'react-router-dom'
import ReactCalendar from 'react-calendar'
import { useReduxSelector } from 'store'
import { useState } from 'react'

const dateStrToObj = (s) => s ? new Date(s) : undefined

const Calendar = ({ response, selectedData, selectData, redirect = () => { } }) => {
  const { id } = useParams()
  const [date, setDate] = useState(dateStrToObj(selectedData.date))
  const { terminationTerms } = useReduxSelector(state => selectWarehouse(state, id))
  const warehouseData = response?.warehouses?.[0]

  const { t, lang } = useTranslation('warehouse')

  return <>
    <div className='title'>
      <div>{t('selectDate')}</div>
      <div>{t('whenDoYouWantToEndYourRent')}</div>
    </div>

    <div className='resignation__main'>
      <div className='resignation__calendar popup__calendar__container'>
        <div className='calendar__labels group'>
          <div>{t('end')}: <span>{date ? toLongDate(date, lang, true) : t('select')}</span></div>
          <div>{t('toPay')}: <span>{response?.warehouses?.[0]?.grossAmount}zł</span></div>
        </div>

        <ReactCalendar
          value={date}
          locale={lang}
          className='--light'
          maxDate={dateStrToObj(warehouseData?.endingDate)}
          minDate={dateStrToObj(warehouseData?.minTerminationDate)}
          defaultActiveStartDate={warehouseData?.minTerminationDate ? new Date(warehouseData?.minTerminationDate) : new Date()}
          showNeighboringMonth={false}
          onChange={value => {
            setDate(value)
            selectData(prev => ({ ...prev, date: dateToYMDformat(value) }))
          }}
        />

        <div className='calendar__info'><b>{t('noticePeriod')}: </b><div>{terminationTerms?.infoForClient}</div></div>
      </div>

      <div className='resignation__buttons'>
        <ArrowBtn
          enlarged
          text={t('next')}
          disabled={!date}
          action={redirect}
        />
        <BackBtn />
      </div>
    </div>
  </>
}

export default Calendar